import { defineMessages } from "react-intl";

export default defineMessages({
  label: {
    id: "Unknown.CheckboxGroup.label",
    defaultMessage: "{title} for ",
  },
});
